import request from '../utils/request'

export function modifyMaterial(material) {
    return request({
        url: '/api/material/modify',
        method: 'post',
        data: material
    })
}


export function deleteMaterial(materialId) {
    return request({
        url: '/api/com/delete',
        params: {
            table: 'report_material',
            id: materialId
        }
    })
}
